export const employeeTypes = {
    loading: "LOADING_EMPLOYEE",
    delete: "DELETE_EMPLOYEE",
    loadedOne: "LOADED_EMPLOYEE",
    loadedMultiple: "LOADED_EMPLOYEES",
    success: "SUCCESS_EMPLOYEE",
};
